import React from 'react';
import { connect } from 'react-redux';

import {
  getIsUsingV1Styles,
  getRenderAsMobile,
  getSectionBackgroundData,
  getSectionFallbackBackgroundData,
  getIsCurrentSubpageFullPageSection
} from 'zoomforth_codesbane_viewer/reducers/index.js';

import {
  isFullWidthSection,
  getMarginStyle,
  getPaddingStyle,
  getCssClassesList
} from 'zoomforth_codesbane_viewer/lib/sections.js';

import {
  getBackgroundStyle,
  getBackgroundClasses,
  getBackgroundVideoParams,
  getCanUseFallbackBackground
} from 'zoomforth_codesbane_viewer/lib/section_backgrounds.js';

import SectionManagerForViewer from './section_manager_for_viewer.jsx';
import SectionManagerForViewerFullWidth from './section_manager_for_viewer.fullwidth.jsx';

const mapStateToProps = (state, { section }) => {
  const isUsingV1Styles = getIsUsingV1Styles(state);
  const isFullPage = getIsCurrentSubpageFullPageSection(state);
  const isMobile = getRenderAsMobile(state);
  const isSectionFullWidth = isFullWidthSection(section);
  const cssClassesList = getCssClassesList(section);

  const sectionBackgroundData = getSectionBackgroundData(state, section);
  const canUseFallbackBackground = getCanUseFallbackBackground(sectionBackgroundData);

  // mobile displays should not inherit the default margin and padding styles
  // we have set for desktop as they can servely ruin mobile layouts
  const sectionMarginStyle = isMobile ? {} : getMarginStyle(section);
  const sectionPaddingStyle = isMobile ? {} :  getPaddingStyle(section);

  var backgroundStyle;
  var backgroundVideoParams;

  if (canUseFallbackBackground && isMobile) {
    backgroundStyle = getBackgroundStyle(getSectionFallbackBackgroundData(state, section));
    backgroundVideoParams = null;
  } else {
    backgroundStyle = getBackgroundStyle(sectionBackgroundData);
    backgroundVideoParams = getBackgroundVideoParams(sectionBackgroundData);
  }

  const backgroundClasses = getBackgroundClasses(sectionBackgroundData);
  const { isGlassOverlayEnabled, isCustomOverlayEnabled, overlayOpacity, overlayColor } = sectionBackgroundData;

  return {
    backgroundStyle,
    backgroundVideoParams,
    backgroundClasses,
    cssClassesList,
    isGlassOverlayEnabled,
    isCustomOverlayEnabled,
    overlayOpacity,
    overlayColor,
    isMobile,
    isFullPage,
    isUsingV1Styles,
    isSectionFullWidth,
    sectionMarginStyle,
    sectionPaddingStyle
  };
};

const mapDispatchToProps = () => ({});

const SectionManagerSwitcher = ({ isSectionFullWidth, isFullPage, isMobile, ...props }) => (
  (isFullPage || isMobile || isSectionFullWidth) ?
    <SectionManagerForViewerFullWidth {...props} />
  :
    <SectionManagerForViewer {...props} />
);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SectionManagerSwitcher);
